module.exports = __webpack_public_path__ + "static/media/3.05589640.jpg";